import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { performLogoutActions } from "store/commonActions"

export const useLogout = () => {
  const dispatch = useDispatch()
  const history = useNavigate()
  const { userType } = useSelector((state) => state.user)

  const logout = async () => {
    performLogoutActions(dispatch)
    if (userType && userType === "ADMIN") {
      history("/admin/login")
    } else {
      history("/login")
    }
  }

  return logout
}
